module.exports = "\r\n<app-full-layout></app-full-layout>"